export default __webpack_public_path__ + "static/media/bannerImg.56b07df4.png";